import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

export const removeDuplicates = (data: IWWPartners[]) => {
  return data.filter(
    (value, index, self) => index === self.findIndex((t) => t.PartnerID === value.PartnerID)
  )
}
